import { Injectable } from '@angular/core';

import moment from 'moment';
import { Service } from '@shared/service/models';
import { getServicesDurationForPartySize } from '@shared/service/functions';

@Injectable({ providedIn: 'root' })
export class DateService {
  //TODO: the same as schedule-provider.service-> checkServicesDuration
  checkServicesDuration(services: Service[], selectedServiceIds: string[], partySize: number): number {
    return getServicesDurationForPartySize(services, selectedServiceIds, partySize);
  }

  convertTimestampToHour(time, timezone) {
    return time.map((i) => {
      if (i === '') {
        return i;
      }
      const date = moment(Number(i)).tz(timezone);
      const hours = date.format('h');
      const minutes = date.format('mm');
      const meridiem = date.format('A');
      return {
        hours,
        minutes,
        meridiem,
        timestamp: i
      };
    });
  }
}
